import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8522e7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TranscriptId" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Загрузка данных транскрипта...", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paper-plane" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_10 = { class: "bg-white border px-6 py-4 mt-6" }
const _hoisted_11 = { class: "bg-white border px-6 py-4 mt-6" }
const _hoisted_12 = { class: "font-semibold text-xl" }
const _hoisted_13 = { class: "bg-white border px-6 py-4 mt-6" }
const _hoisted_14 = { class: "font-semibold text-xl" }
const _hoisted_15 = {
  key: 0,
  class: "flex items-center justify-center mt-4 p-3"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, "Нет накладных", -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_transcript_file = _resolveComponent("transcript-file")!
  const _component_one_c_file = _resolveComponent("one-c-file")!
  const _component_transcript_calculation = _resolveComponent("transcript-calculation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_failed_fetch, {
          key: 0,
          loading: _ctx.state.is_loading,
          text: "При получении данных транскрипта произошла ошибка",
          onRefresh: _ctx.loadTranscript
        }, null, 8, ["loading", "onRefresh"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_3
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_page_title, { title: "Транскрипт" }),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_the_button, {
                      class: "primary small mr-2",
                      onClick: _ctx.downloadTranscript,
                      hint: "Скачать подписанный документ"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    (_ctx.isCanSend)
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 0,
                          class: "primary small",
                          onClick: _ctx.sendTranscript,
                          hint: "Отправить на подпись"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_the_button, {
                      class: "second small text",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/billing/transcripts')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9,
                        _createTextVNode(" Назад ")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", null, "Номер акта: " + _toDisplayString(_ctx.state.transcript?.actNumber), 1),
                  _createElementVNode("p", null, "Дата создания: " + _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.transcript?.actFrom1CCreatedAt)), 1),
                  _createElementVNode("p", null, " Контрагент: " + _toDisplayString(_ctx.state.transcript.company
                                ? _ctx.state.transcript.company.short_name
                                : 'Нет данных'), 1),
                  _createElementVNode("p", null, "Общая сумма: " + _toDisplayString(_ctx.state.transcript.finalAmount), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, " Файлы (" + _toDisplayString(_ctx.state.transcript?.files.length) + ") ", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.transcript?.files, (file) => {
                    return (_openBlock(), _createBlock(_component_transcript_file, {
                      class: "flex items-center justify-between mt-4 border p-3",
                      key: file.path,
                      file: file,
                      "act-number": _ctx.state.transcript.actNumber,
                      "created-at": _ctx.state.transcript.actFrom1CCreatedAt
                    }, null, 8, ["file", "act-number", "created-at"]))
                  }), 128)),
                  _createVNode(_component_one_c_file, {
                    "transcript-id": _ctx.state.transcript?.id,
                    class: "flex items-center justify-between mt-4 border p-3"
                  }, null, 8, ["transcript-id"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", _hoisted_14, " Накладные (" + _toDisplayString(_ctx.state.transcript.calculations.length) + ") ", 1),
                  (_ctx.state.transcript.calculations.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.transcript.calculations, (calculation) => {
                    return (_openBlock(), _createBlock(_component_transcript_calculation, {
                      class: "mt-4 border p-3",
                      "can-print": 
                            _ctx.havePermissions([
                                'order-logistics-info-ttn-info',
                                'all-root-permission',
                            ])
                        ,
                      key: calculation,
                      calculation: calculation,
                      "transcript-id": _ctx.transcript_id
                    }, null, 8, ["can-print", "calculation", "transcript-id"]))
                  }), 128))
                ])
              ]))
        ], 64))
  ]))
}